<!-- Ported from the Polaris kit: src/product/components/Invitation.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand changes (phase 4.2):
     - The art at the right is the Polaris animation of D-G3 (`art`, PolarisArt.vue, PROVISÓRIO: R2-4-4 → X-4 = B),
       not one of the kit's eight scenes (ArtScene is not ported).
     - No help links (R2-4-2 = C: the links pointed to another product's docs; only the action stays).
     - Logical `end-*`/`pe-*` for the close button and the text's room (RTL).
     - The close button's name in i18n. -->
<script setup>
// The invitation at the top of a page: what this place is for and one way to start. It can be dismissed; whoever
// shows it remembers that. A title, a sentence, an action. With `art` it also shows art at the right: it teaches, it
// never sells, and it is left out when there is no room.
import { useI18n } from 'vue-i18n';
import { Close16 } from '@carbon/icons-vue';
import { Button } from '../ui/button';
import PolarisArt from '../art/PolarisArt.vue';

defineProps({
  title: { type: String, required: true },
  text: { type: String, required: true },
  actionLabel: { type: String, default: '' },
  art: { type: Boolean, default: true },
  tone: { type: String, default: 'sky' },
});
defineEmits(['action', 'dismiss']);

const { t } = useI18n();
</script>

<template>
  <!-- The art follows the room the banner has, not the viewport. From 32rem it shows the art in 14rem, from 42rem in 18rem. -->
  <div class="@container">
    <div
      class="relative rounded-polaris-xl bg-polaris-muted"
      :class="
        art
          ? 'grid gap-4 p-3 @lg:grid-cols-[minmax(0,1fr)_14rem] @2xl:grid-cols-[minmax(0,1fr)_18rem]'
          : ''
      "
      data-banner
      :data-banner-art="art ? '' : undefined"
    >
      <div
        class="grid gap-2"
        :class="art ? 'content-center p-3 pe-12 @lg:pe-3' : 'p-6 pe-12'"
      >
        <h2 class="type-polaris-section-title">{{ title }}</h2>
        <p class="max-w-prose type-polaris-body text-polaris-muted-foreground">
          {{ text }}
        </p>
        <div
          v-if="actionLabel"
          class="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2"
        >
          <Button size="sm" @click="$emit('action')">{{ actionLabel }}</Button>
        </div>
      </div>
      <PolarisArt v-if="art" :tone="tone" class="hidden min-h-40 @lg:block" />
      <Button
        :variant="art ? 'secondary' : 'ghost'"
        size="icon-sm"
        class="absolute"
        :class="art ? 'top-5 end-5 rounded-full' : 'top-3 end-3'"
        :aria-label="t('POLARIS.PAGES.INVITATION.DISMISS')"
        @click="$emit('dismiss')"
      >
        <Close16 aria-hidden="true" />
      </Button>
    </div>
  </div>
</template>
